import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyService } from '../services/company/company.service';

@Injectable({
  providedIn: 'root',
})
export class EstablishmentIdInterceptor implements HttpInterceptor {
  constructor(private companyService: CompanyService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.companyService.currentEstablishment) {
      request = request.clone({
        setHeaders: {
          'x-establishment-id': this.companyService.currentEstablishment,
        },
      });
    }

    return next.handle(request);
  }
}
